import React from "react";
import { PublicLayout, PageContainer, PageHeader } from "@/components/PublicLayout";
import { useSeo } from "@/lib/useSeo";

const SECTIONS = [
  { h: "1. Acceptance of Terms", p: "By accessing Guwahati Morning Teer, you agree to be bound by these Terms & Conditions. If you do not agree, please do not use the website." },
  { h: "2. Informational Purpose Only", p: "All content on this website, including results, numbers, charts and articles, is provided strictly for informational and archival purposes. Nothing on this site constitutes advice, prediction, or a recommendation." },
  { h: "3. No Betting or Gambling", p: "This website does not offer, facilitate, or encourage betting, gambling, lotteries, payments, or any form of wagering. We are not affiliated with any lottery or gaming authority." },
  { h: "4. Accuracy of Information", p: "While we strive to publish accurate and timely results, we make no guarantee regarding completeness or accuracy. Results should be independently verified." },
  { h: "5. Limitation of Liability", p: "We are not liable for any loss or damage arising from the use of, or reliance on, information presented on this website." },
  { h: "6. Intellectual Property", p: "The design, layout, and original content of this website are owned by Guwahati Morning Teer and may not be reproduced without permission." },
  { h: "7. User Conduct", p: "You agree not to misuse the website, attempt unauthorized access, or use it for any unlawful purpose." },
  { h: "8. Governing Law", p: "These terms are governed by the applicable laws of India. Any disputes shall be subject to the jurisdiction of local courts." },
  { h: "9. Changes to Terms", p: "We reserve the right to modify these terms at any time. Continued use signifies acceptance of the updated terms." },
];

export default function Terms() {
  useSeo({ title: "Terms & Conditions | Guwahati Morning Teer", description: "Terms and Conditions of Guwahati Morning Teer. Informational website only, no betting or payments.", path: "/terms" });
  return (
    <PublicLayout>
      <PageContainer className="py-10 max-w-3xl">
        <PageHeader eyebrow="Legal" title="Terms & Conditions" subtitle="Last updated: 2026" />
        <div className="space-y-6">
          {SECTIONS.map((s, i) => (
            <div key={i} data-testid={`terms-section-${i}`}>
              <h3 className="font-heading font-bold text-lg text-slate-900">{s.h}</h3>
              <p className="text-slate-600 leading-relaxed mt-1.5">{s.p}</p>
            </div>
          ))}
        </div>
      </PageContainer>
    </PublicLayout>
  );
}
